import { createContext, useContext } from "react";
import type { StripeAddressElementChangeEvent } from "@stripe/stripe-js";
import type { UseMutationResult } from "react-query";
import type { ApiError } from "@/react/config/CustomErrors";
import type { CommunityMemberBillingInfo } from "@circle-react/types";
import type { BillingInfoContextProps } from "./BillingInfoContextProps";
import type { BillingInfoFormValues } from "./BillingInfoFormValues";

export interface BillingInfoContextState
  extends Omit<BillingInfoContextProps, "onSuccess"> {
  areAddressFieldsReady: boolean;
  billingInfoMutation: UseMutationResult<
    CommunityMemberBillingInfo,
    ApiError,
    BillingInfoFormValues,
    unknown
  >;
  markAddressFieldsReady: () => void;
  setAddress: (event: StripeAddressElementChangeEvent) => void;
}

export const BillingInfoContext = createContext<BillingInfoContextState>(
  {} as BillingInfoContextState,
);
BillingInfoContext.displayName = "BillingInfoContext";

export const useBillingInfoContext = () => useContext(BillingInfoContext);
